/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
// import { PlansState } from 'store/modules/plans_store/types';

interface CardPaymentProps {
  cardHolderName: string;
  setCardHolderName: React.Dispatch<React.SetStateAction<string>>;
  cardNumber: string;
  setCardNumber: React.Dispatch<React.SetStateAction<string>>;
  cardExpirationMonth: string;
  setCardExpirationMonth: React.Dispatch<React.SetStateAction<string>>;
  cardExpirationYear: string;
  setCardExpirationYear: React.Dispatch<React.SetStateAction<string>>;
  cardCvv: string;
  setCardCvv: React.Dispatch<React.SetStateAction<string>>;
  cardBrand: string;
  setCardBrand: React.Dispatch<React.SetStateAction<string>>;
}

const CardPayment = (props: CardPaymentProps) => {
  const {
    cardHolderName,
    setCardHolderName,
    cardNumber,
    setCardNumber,
    cardExpirationMonth,
    setCardExpirationMonth,
    cardExpirationYear,
    setCardExpirationYear,
    cardCvv,
    setCardCvv,
    cardBrand,
    setCardBrand,
  } = props;

  const [touchedNumber, setTouchedNumber] = useState<boolean>(false);
  const [errorNumber, setErrorNumber] = useState<string | boolean>(false);
  const [touchedCardHolderName, setTouchedCardHolderName] = useState<boolean>(false);
  const [errorCardHolderName, setErrorCardHolderName] = useState<string | boolean>(false);
  const [touchedCardExpirationMonth, setTouchedCardExpirationMonth] = useState<boolean>(false);
  const [errorCardExpirationMonth, setErrorCardExpirationMonth] = useState<string | boolean>(false);
  const [touchedCardExpirationYear, setTouchedCardExpirationYear] = useState<boolean>(false);
  const [errorCardExpirationYear, setErrorCardExpirationYear] = useState<string | boolean>(false);
  const [touchedCardCvv, setTouchedCardCvv] = useState<boolean>(false);
  const [errorCardCvv, setErrorCardCvv] = useState<string | boolean>(false);
  const [touchedCardBrand, setTouchedCardBrand] = useState<boolean>(false);
  const [errorCardBrand, setErrorCardBrand] = useState<string | boolean>(false);

  const checkCardNumber = () => {
    const unmaskedCardNumber = cardNumber.replace(/\D/g, '');

    if (!unmaskedCardNumber) return 'Número do cartão não pode ser vazio';
    if (unmaskedCardNumber?.length < 16 && cardBrand !== 'Amex')
      return 'Número do cartão deve estar completo';
    if (unmaskedCardNumber?.length < 15 && cardBrand === 'Amex')
      return 'Número do cartão deve estar completo';
    return false;
  };

  const checkCardHoldName = () => {
    if (!cardHolderName) return 'Nome impresso no cartão não pode ficar vazio';
    return false;
  };

  const checkCardCvv = () => {
    if (!cardCvv) return 'Código de segurança não pode ficar vazio';
    return false;
  };

  const checkCardExpirationMonth = () => {
    if (!cardExpirationMonth) return 'Mês de expiração não pode ficar vazio';
    return false;
  };

  const checkCardExpirationYear = () => {
    if (!cardExpirationYear) return 'Ano de expiração não pode ficar vazio';
    return false;
  };

  const checkCardBrand = () => {
    if (!cardBrand) return 'Emissor não pode ficar vazio';
    return false;
  };

  useEffect(() => {
    if (touchedCardHolderName) {
      setErrorCardHolderName(checkCardHoldName());
    }
    if (touchedNumber) {
      setErrorNumber(checkCardNumber());
    }

    if (touchedCardExpirationMonth) {
      setErrorCardExpirationMonth(checkCardExpirationMonth());
    }

    if (touchedCardExpirationYear) {
      setErrorCardExpirationYear(checkCardExpirationYear());
    }

    if (touchedCardCvv) {
      setErrorCardCvv(checkCardCvv());
    }
    if (touchedCardBrand) {
      setErrorCardBrand(checkCardBrand());
    }
  }, [
    touchedCardHolderName,
    cardHolderName,
    touchedNumber,
    touchedCardExpirationMonth,
    touchedCardExpirationYear,
    touchedCardCvv,
    touchedCardBrand,
  ]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="brand">Emissor</label>
            <select
              id="cardBrand"
              className={`form-control ${errorCardBrand && touchedCardBrand && 'is-invalid'}`}
              onChange={(event) => setCardBrand(event.target.value)}
              defaultValue=""
              onBlur={() => setTouchedCardBrand(true)}
            >
              <option value="" disabled>
                Selecione...
              </option>
              <option value="Visa">Visa</option>
              <option value="Master">Master</option>
              <option value="Amex">American Express</option>
              <option value="Elo">Elo</option>
              <option value="JCB">JCB</option>
              <option value="Diners">Diners</option>
              <option value="Hipercard">Hipercard</option>
            </select>
            <div className={`invalid-feedback ${errorCardBrand ? 'd-block' : 'd-none'} `}>
              {errorCardBrand}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cardHolderName"> Nome impresso no cartão</label>
            <input
              id="cardHolderName"
              type="text"
              className={`form-control ${
                errorCardHolderName && touchedCardHolderName && 'is-invalid'
              }`}
              onChange={(event) => setCardHolderName(event.target.value)}
              value={cardHolderName}
              onBlur={() => setTouchedCardHolderName(true)}
            />
            <div className={`invalid-feedback ${errorCardHolderName ? 'd-block' : 'd-none'} `}>
              {errorCardHolderName}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="cardNumber">Número do cartão</label>
            <InputMask
              id="cardNumber"
              type="text"
              className={`form-control ${errorNumber && touchedNumber && 'is-invalid'}`}
              pattern="[0-9 ]{19}"
              mask={cardBrand !== 'Amex' ? '9999 9999 9999 9999' : '99999 99999 99999'}
              onChange={(event) => setCardNumber(event.target.value)}
              value={cardNumber}
              onBlur={() => setTouchedNumber(true)}
            />
            <div className={`invalid-feedback ${errorNumber ? 'd-block' : 'd-none'} `}>
              {errorNumber}
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-3 mb-3">
              <label htmlFor="cardExpirationMonth">Mês</label>
              <InputMask
                id="cardExpirationMonth"
                className={`form-control ${
                  errorCardExpirationMonth && touchedCardExpirationMonth && 'is-invalid'
                }`}
                mask="99"
                onChange={(event) => setCardExpirationMonth(event.target.value)}
                value={cardExpirationMonth}
                onBlur={() => setTouchedCardExpirationMonth(true)}
              />
              <div
                className={`invalid-feedback ${errorCardExpirationMonth ? 'd-block' : 'd-none'} `}
              >
                {errorCardExpirationMonth}
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <label>Ano</label>
              <InputMask
                id="cardExpirationYear"
                className={`form-control ${
                  errorCardExpirationYear && touchedCardExpirationYear && 'is-invalid'
                }`}
                onChange={(event) => setCardExpirationYear(event.target.value)}
                value={cardExpirationYear}
                mask="99"
                onBlur={() => setTouchedCardExpirationYear(true)}
              />
              <div
                className={`invalid-feedback ${errorCardExpirationYear ? 'd-block' : 'd-none'} `}
              >
                {errorCardExpirationYear}
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="cardCvv">Cód. Segurança</label>
              <InputMask
                id="cardCvv"
                type="text"
                className={`form-control ${errorCardCvv && touchedCardCvv && 'is-invalid'}`}
                pattern="[0-9]{3,4}( )?"
                onChange={(event) => setCardCvv(event.target.value)}
                value={cardCvv}
                mask={`${cardBrand === 'Amex' ? '9999' : '999'}`}
                onBlur={() => setTouchedCardCvv(true)}
              />
              <div className={`invalid-feedback ${errorCardCvv ? 'd-block' : 'd-none'} `}>
                {errorCardCvv}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardPayment;
